"use strict";

angular.module('app.models.sceneAction', []).//
factory('__SceneSourceData', function (restmod, appConfig) {
    'ngInject';
    
    return restmod.model('/Scene').mix('BaseModel').mix({
        '_type': {map: '$type'},
        'DatapointValue._type': {map: '$type'},

        $hooks: {
            'after-feed': function (data) {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }
                if(this._type == "BMS.Shared.SceneData.Sources.SceneDataSourceBase, BMS.Shared" || this._type == undefined)
                {
                    this._type = "BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared";
                }
                if(this._type == "BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared"){
                    if(!this.ConstantValue ){
                        this.ConstantValue = 0;
                    }
                    if(! this.DatapointType){
                        this.DatapointType = 0;
                    }
                    if(this.DatapointType === 2)
                    {
                        // Parse incoming Constant Values By Datapoint Type
                        this.ConstantValue = this.ConstantValue == "True" ? true : false;
                    }
                }


            }
        }

    });
}).factory('__SceneActionSetDatapointValue', function (restmod) {
    'ngInject';
    
    return restmod.model('/Scene').mix('BaseModel').mix({
        'DatapointValue': {'hasOne': '__DatapointValue'},

        //'$UI.$Datapoint' : {'hasOne':'__Datapoint'},
        //'SourceData': {'hasOne': '__SceneSourceData'},
        //'Offset': {'hasOne': '__SceneSourceData'},
        'DatapointValue._type': {map: '$type'},
        //'SourceData._type': {map: '$type'},
        $hooks: {
            'after-feed': function (data) {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }
/*
                if (this.SourceData == undefined) {
                    var o = {};
                    this.SourceData = __SceneSourceData.$buildRaw(o);
                }
*/
            }
        }

    });
}).factory('__SceneAction', function (restmod, __SceneActionSetDatapointValue, __SceneSourceData) {
    'ngInject';
    
    return restmod.model('/Scene').mix('BaseModel').mix({
        $pk: 'Id',
        'Data._type': {map: '$type'},
        // 'Data.Values': {'hasMany': '__SceneActionSetDatapointValue' },
        $hooks: {
            'after-feed': function (data) {
                if (this.Data._type == "BMS.Shared.SceneData.Actions.SceneDataActionSetDatapoints, BMS.Shared" && this.Data.Values) {
                    for (var i = 0; i < this.Data.length; i++) {

                        this.Data[i] = __SceneActionSetDatapointValue.$buildRaw(this.Data[i]);
                    }
                }
                this.prepareAction();
            }
        }, /* Prepare Condition Tree */
        genActionKey: function (SV) {
            var filter = {};
            var key = '';

            if (SV.DatapointValue.DeviceId != conf_guidF.toLowerCase()) {
                filter =
                {
                    "Type": "DeviceIdFilter",
                    "DeviceId": SV.DatapointValue.DeviceId,
                    "DeviceType": SV.DeviceType
                };
                key = 'DI:' + SV.DatapointValue.DeviceId;
            } else {
                filter =
                {
                    "Type": "MenuEntryFilter",
                    "MenuEntrys": SV.MenuEntryFilter,
                    "DeviceType": SV.DeviceType

                };
                if (SV.MenuEntryFilter && SV.MenuEntryFilter.length > 0) {
                    var mf = SV.MenuEntryFilter.join('+');
                } else {
                    mf = '';
                }
                key = 'DT:' + SV.DeviceType + '|MEF:[' + ( mf + ']' );
            }


            return {
                "Filter": filter,
                "Key": key
            };
        }
        ,
        prepareAction: function () {
            if (this.$UI == undefined) {
                this.$UI = {};
            }

            if (!this.Data.Description) {
                this.Data.Description = null
            }
            ;
            if (this.Data.Enabled == undefined) {
                this.Data.Enabled = true
            }
            ;
            if (!this.Data.PostDelayMs || this.Data.PostDelayMs < 0) {
                this.Data.PostDelayMs = 0
            }
            ;
            if (!this.Data.PreDelayMs  || this.Data.PreDelayMs < 0) {
                this.Data.PreDelayMs = 0
            };

            if (this.Data.ForceWrite == undefined) {
                this.Data.ForceWrite = false
            };


            switch (this.Data._type) {
                // Set Datapoints Action
                case "BMS.Shared.SceneData.Actions.SceneDataActionSetDatapoints, BMS.Shared":
                    /*
                    SampleObject: {
                        "Enabled": true,
                        "DeviceType": 2,
                        "DatapointValue": {
                            "$type": "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared",
                            "Value": 55,
                            "DatapointConfigId": "f3712586-33f3-41e6-9b11-20f1e7a1a363",
                            "DeviceId": "bb8e14e4-8e61-4746-acd7-874cc75ed6a8",
                            "Flags": 0
                        },
                        "SourceData": null,
                        "Offset": null,
                        "MenuEntryFilter": null
                    }
                    */

                    // alert(this.Data.Values[0].DatapointValue._type);
                    if (this.Data.Values) {
                        for (var j = 0; j < this.Data.Values.length; j++) {
                            this.Data.Values[j] = __SceneActionSetDatapointValue.$buildRaw(this.Data.Values[j]);
                            // this.Data.Values[j].$UI = {};
                            var val = this.Data.Values[j];

                            if (val.DatapointValue.DeviceId == "ffffffff-ffff-ffff-ffff-ffffffffffff") {
                                val.$UI.SingularPlural = 'Plural';

                            } else {
                                val.$UI.SingularPlural = '';
                            }
                            if (!val.SourceData || val.SourceData._type == undefined) {
                                val.SourceData = __SceneSourceData.$buildRaw({
                                    "$type": "BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared",
                                    "ConstantValue": val.DatapointValue.Value
                                });
                            }

                        }
                    }


                    break;
            }

        }
    })


})
;
